import React from "react";

import Slide from "react-reveal/Slide";
import Flip from "react-reveal/Flip";

import image1 from "../assets/quote1.jpg";

export default function Quote1() {
  return (
    <>
      <Flip left cascade>
        <div
          className="container-content"
          style={{
            borderRadius: "10px 80px 10px 80px",
            padding: "40px 25px 80px 25px",
            zIndex: 1,
          }}
        >
          <i className="fas fa-heart"></i>
          <p
            className="garamond-font"
            style={{ fontSize: 16, color: "black", marginTop: 20 }}
          >
            “And of His signs is that He created for you from yourselves mates
            that you may find tranquillity in them; and He placed between you
            affection and mercy. Indeed in that are signs for a people who give
            thought.”
          </p>
          <p
            className="garamond-font"
            style={{
              fontSize: 16,
              color: "black",
              marginTop: 10,
              fontWeight: "bold",
            }}
          >
            ( QS. Ar- Rum 21 )
          </p>
        </div>
      </Flip>
      <Slide bottom>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "-80px",
            zIndex: "-1",
          }}
        >
          <div style={{ width: "75%" }}>
            <img
              src={image1}
              className="quote-image"
              objectfit="cover"
              width="100%"
              height="100%"
              style={{ borderRadius: "10px", zIndex: "-1" }}
            />
          </div>
        </div>
      </Slide>
    </>
  );
}
